import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import MaterialTable from 'material-table'
import { withStyles } from '@material-ui/core'
import { dateFormat, getMonthAndYear, maskCpf, maskCnpj } from '../../../class/utils'
import { Loader } from '../../default'

function TableLog({
    classes, logs, loadingLogs
}) {
    const { t } = useTranslation()

    const prepareColumns = () => {
        return [
            { title: t('panels.managerLog.table.columns.manager_email'), field: 'manager_email' },
            { title: t('panels.managerLog.table.columns.timestamp'), field: 'timestamp', defaultSort: 'desc' },
            { title: t('panels.managerLog.table.columns.action_class'), field: 'action_class' },
            { title: t('panels.managerLog.table.columns.action'), field: 'action' },
            { title: t('panels.managerLog.table.columns.month'), field: 'month' },
            { title: t('panels.managerLog.table.columns.status'), field: 'status' }
        ];
    }

    const prepareData = () => {
        if (!logs) {
            return []
        }

        return logs.map(log => {

            return {
                manager_email: log.MANAGER_EMAIL,
                timestamp: dateFormat(log.TIMESTAMP),
                action_class: t(`panels.managerLog.selectActionClassField.${log.ACTION_CLASS}`),
                action: t(`panels.managerLog.selectActionField.${log.ACTION}`),
                month: getMonthAndYear(log.MONTH),
                status: t(`panels.managerLog.table.data.status.${log.STATUS}`),

                //Product, ProductTable, ProductPrice, Plan, PlanProduct, PlanTable & PlanPrices
                product_id: log.PRODUCT_ID,
                name: log.NAME,
                description: log.DESCRIPTION,
                bureau_id: log.BUREAU_ID,
                plan_id: log.PLAN_ID,
                discount: log.DISCOUNT,
                special: log.SPECIAL ? t('panels.managerLog.table.details.yes') : t('panels.managerLog.table.details.no'),
                valid_until: dateFormat(log.VALID_UNTIL),
                plan_table_id: log.PLAN_TABLE_ID,
                current_table: log.CURRENT_TABLE,
                price: log.PRICE,

                //Subscription
                customer_id: log.CUSTOMER_ID,

                //Filter
                filter_id: log.FILTER_ID,

                //Notification
                notification_id: log.NOTIFICATION_ID,
                message: log.MESSAGE,
                notification_type: t(`modals.notifications.manage.table.type.${log.NOTIFICATION_TYPE}`),
                redirect_url: log.REDIRECT_URL ? log.REDIRECT_URL : '-',

                //Config
                config_id: log.CONFIG_ID,
                value: log.VALUE,

                //Customer
                cnpj: maskCnpj(log.CNPJ),
                cpf: maskCpf(log.CPF),
                payment_gateway_id: log.PAYMENT_GATEWAY_ID,
                first_name: log.FIRST_NAME,
                last_name: log.LAST_NAME,
                is_manager: log.IS_MANAGER ? t('panels.managerLog.table.details.yes') : t('panels.managerLog.table.details.no'),
                is_verified: log.IS_VERIFIED ? t('panels.managerLog.table.details.yes') : t('panels.managerLog.table.details.no'),
                is_blocked: log.IS_BLOCKED ? t('panels.managerLog.table.details.yes') : t('panels.managerLog.table.details.no'),
                email: log.EMAIL,
                phone_1: log.PHONE_1,
                proudct_table_id: log.PRODUCT_TABLE_ID,
                marketplace_id: log.MARKETPLACE_ID ? log.MARKETPLACE_ID : '-',

                //Payment
                amount: log.AMOUNT,
                billingType: log.BILLINGTYPE,
                url: log.URL,
                max_payments: log.MAX_PAYMENTS,

                //Sale
                sale_id: log.SALE_ID,
                valid_from: dateFormat(log.VALID_FROM),
                valid_to: dateFormat(log.VALID_TO)

            }
        })

    }

    return (
        <>
            {
                loadingLogs ? <Loader /> : (
                    <MaterialTable
                        columns={prepareColumns()}
                        data={prepareData()}
                        localization={t('materialTableLocale', { returnObjects: true })}
                        options={{
                            toolbar: false
                        }}
                        detailPanel={rowData => {

                            switch (rowData.action) {

                                //Product
                                //case 'Criação de Produto':
                                case 'Alteração de Produto':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateProduct')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.productId')}</b>{rowData.product_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                            <p><b>{t('panels.managerLog.table.details.bureauId')}</b>{rowData.bureau_id}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Produto':

                                //ProductTable
                                //case 'Criação de Tabela de Produtos':
                                //case 'Alteração de Tabela de Produtos':
                                //case 'Exclusão de Tabela de Produtos':

                                //ProductPrice
                                //case 'Atribuição de Preço a Produto':
                                //case 'Alteração de Preço de Produto':
                                //case 'Exclusão de Preço de Produto':

                                //Plan
                                case 'Criação de Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreatePlan')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                            <p><b>{t('panels.managerLog.table.details.discount')}</b>{rowData.discount}</p>
                                            <p><b>{t('panels.managerLog.table.details.special')}</b>{rowData.special}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil')}</b>{rowData.valid_until}</p>
                                        </div>
                                    )
                                case 'Alteração de Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdatePlan')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                            <p><b>{t('panels.managerLog.table.details.discount')}</b>{rowData.discount}</p>
                                            <p><b>{t('panels.managerLog.table.details.special')}</b>{rowData.special}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil')}</b>{rowData.valid_until}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Plano':

                                //PlanProduct
                                case 'Atribuição de Desconto a Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreatePlanProduct')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.productId')}</b>{rowData.product_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.discount')}</b>R$ {rowData.discount}</p>
                                        </div>
                                    )
                                case 'Alteração de Desconto de Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdatePlanProduct')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.productId')}</b>{rowData.product_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.discount')}</b>R$ {rowData.discount}</p>
                                        </div>
                                    )
                                case 'Exclusão de Desconto de Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.DeletePlanProduct')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.productId')}</b>{rowData.product_id}</p>
                                        </div>
                                    )

                                //PlanTable
                                case 'Criação de Tabela de Planos':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreatePlanTable')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planTableId')}</b>{rowData.plan_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_until}</p>
                                            <p><b>{t('panels.managerLog.table.details.currentTable')}</b>{rowData.current_table}</p>
                                        </div>
                                    )
                                case 'Alteração de Tabela de Planos':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdatePlanTable')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planTableId')}</b>{rowData.plan_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_until}</p>
                                            <p><b>{t('panels.managerLog.table.details.currentTable')}</b>{rowData.current_table}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Tabela de Planos':

                                //PlanPrices
                                case 'Atribuição de Mensalidade a Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreatePlanPrice')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planTableId')}</b>{rowData.plan_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.value')}</b>R$ {rowData.price}</p>
                                        </div>
                                    )
                                case 'Alteração de Mensalidade de Plano':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdatePlanPrice')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.planTableId')}</b>{rowData.plan_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.value')}</b>R$ {rowData.price}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Mensalidade de Plano':

                                //Subscription
                                case 'Ativação de Assinatura Promocional para Cliente':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.SubscribeCustomer')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                        </div>
                                    )

                                //Filter
                                case 'Criação de Filtro':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreateFilter')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.filterId')}</b>{rowData.filter_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                        </div>
                                    )
                                case 'Alteração de Filtro':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateFilter')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.filterId')}</b>{rowData.filter_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.description')}</b>{rowData.description}</p>
                                        </div>
                                    )
                                case 'Exclusão de Filtro':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.DeleteFilter')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.filterId')}</b>{rowData.filter_id}</p>
                                        </div>
                                    )

                                //Notification
                                case 'Criação de Notificação':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreateNotification')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.notificationId')}</b>{rowData.notification_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_until}</p>
                                            <p><b>{t('panels.managerLog.table.details.type')}</b>{rowData.notification_type}</p>
                                            <p><b>{t('panels.managerLog.table.details.url')}</b>{rowData.redirect_url}</p>
                                            <p><b>{t('panels.managerLog.table.details.message')}</b>{rowData.message}</p>
                                        </div>
                                    )
                                case 'Alteração de Notificação':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateNotification')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.notificationId')}</b>{rowData.notification_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_until}</p>
                                            <p><b>{t('panels.managerLog.table.details.type')}</b>{rowData.notification_type}</p>
                                            <p><b>{t('panels.managerLog.table.details.url')}</b>{rowData.redirect_url}</p>
                                            <p><b>{t('panels.managerLog.table.details.message')}</b>{rowData.message}</p>
                                        </div>
                                    )
                                case 'Exclusão de Notificação':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.DeleteNotification')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.notificationId')}</b>{rowData.notification_id}</p>
                                        </div>
                                    )

                                //Config
                                //case 'Criação de Configuração':
                                case 'Alteração de Configuração':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateConfigEntry')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{t(`panels.managerLog.table.data.other.${rowData.name}`)}</p>
                                            <p><b>{t('panels.managerLog.table.details.value')}</b>R$ {rowData.value}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Configuração':

                                //Customer
                                case 'Bloqueio de Cliente':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.BlockCustomer')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                        </div>
                                    )
                                case 'Desbloqueio de Cliente':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UnblockCustomer')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                        </div>
                                    )
                                case 'Cadastro de Cliente':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreateCustomer')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.first_name} {rowData.last_name}</p>
                                            <p><b>{t('panels.managerLog.table.details.cpf')}</b>{rowData.cpf}</p>
                                            <p><b>{t('panels.managerLog.table.details.cnpj')}</b>{rowData.cnpj}</p>
                                            <p><b>{t('panels.managerLog.table.details.email')}</b>{rowData.email}</p>
                                            <p><b>{t('panels.managerLog.table.details.phone')}</b>{rowData.phone_1}</p>
                                            <p><b>{t('panels.managerLog.table.details.manager')}</b>{rowData.is_manager}</p>
                                            <p><b>{t('panels.managerLog.table.details.verified')}</b>{rowData.is_verified}</p>
                                            <p><b>{t('panels.managerLog.table.details.blocked')}</b>{rowData.is_blocked}</p>
                                            <p><b>{t('panels.managerLog.table.details.paymentGatewayId')}</b>{rowData.payment_gateway_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.marketplaceId')}</b>{rowData.marketplace_id}</p>
                                        </div>
                                    )
                                //case 'Cadastro de Cliente Patrocinado':
                                case 'Alteração de Cadastro de Cliente':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateCustomer')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.first_name} {rowData.last_name}</p>
                                            <p><b>{t('panels.managerLog.table.details.cpf')}</b>{rowData.cpf}</p>
                                            <p><b>{t('panels.managerLog.table.details.manager')}</b>{rowData.is_manager}</p>
                                            <p><b>{t('panels.managerLog.table.details.verified')}</b>{rowData.is_verified}</p>
                                            <p><b>{t('panels.managerLog.table.details.blocked')}</b>{rowData.is_blocked}</p>
                                            <p><b>{t('panels.managerLog.table.details.planTableId')}</b>{rowData.plan_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.productTableId')}</b>{rowData.proudct_table_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.paymentGatewayId')}</b>{rowData.payment_gateway_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.marketplaceId')}</b>{rowData.marketplace_id}</p>
                                        </div>
                                    )
                                //case 'Exclusão de Cadastro de Cliente':

                                //Payment
                                case 'Geração de Cobrança: Avulsa':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreatePayment')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.value')}</b>R$ {rowData.amount}</p>
                                            <p><b>{t('panels.managerLog.table.details.paymentMethod')}</b>{rowData.billingType}</p>
                                            <p><b>{t('panels.managerLog.table.details.url')}</b>{rowData.url}</p>
                                        </div>
                                    )
                                case 'Geração de Cobrança: Assinatura':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreateSubscription')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.customerId')}</b>{rowData.customer_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.value')}</b>R$ {rowData.amount}</p>
                                            <p><b>{t('panels.managerLog.table.details.paymentMethod')}</b>{rowData.billingType}</p>
                                            <p><b>{t('panels.managerLog.table.details.url')}</b>{rowData.url}</p>
                                            <p><b>{t('panels.managerLog.table.details.maximumNumberOfMonthlyFees')}</b>{rowData.max_payments}</p>
                                        </div>
                                    )

                                //Sale
                                case 'Criação de Promoção':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.CreateSale')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.saleId')}</b>{rowData.sale_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.createdAt')}</b>{rowData.valid_from}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_to}</p>
                                        </div>
                                    )
                                case 'Alteração de Promoção':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.UpdateSale')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.saleId')}</b>{rowData.sale_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.planId')}</b>{rowData.plan_id}</p>
                                            <p><b>{t('panels.managerLog.table.details.name')}</b>{rowData.name}</p>
                                            <p><b>{t('panels.managerLog.table.details.createdAt')}</b>{rowData.valid_from}</p>
                                            <p><b>{t('panels.managerLog.table.details.validUntil2')}</b>{rowData.valid_to}</p>
                                        </div>
                                    )
                                case 'Exclusão de Promoção':
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}{t('panels.managerLog.selectActionField.DeleteSale')}</b></p>
                                            <hr></hr>
                                            <p><b>{t('panels.managerLog.table.details.saleId')}</b>{rowData.sale_id}</p>
                                        </div>
                                    )

                                default:
                                    return (
                                        <div className={classes.collapse}>
                                            <p><b>{t('panels.managerLog.table.details.title')}</b></p>
                                            <hr></hr>
                                        </div>
                                    )
                            }

                        }}
                        onRowClick={(event, rowData, togglePanel) => togglePanel()}
                    />
                )
            }
        </>
    )
}

TableLog.propTypes = {
    logs: PropTypes.array,
}

TableLog.defaultProps = {
    logs: []
}

const styles = theme => ({
    collapse: {
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '1px',
        paddingBottom: '1px',
        background: 'rgba(0, 0, 0, 0.02)',
        boxShadow: 'inset 0 0 3px rgb(0, 0, 0, 0.2)'
    }
})

const mapStateToProps = ({ ReducerLog }) => ({
    logs: ReducerLog.logs,
    loadingLogs: ReducerLog.loadingLogs
})

export default connect(mapStateToProps)(withStyles(styles)(TableLog))